import React from "react";

const CalendarIcon = ({
  size = 16,
  className = "text-dark-gray",
  withDots = true,
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M5.334 1.333v2M10.666 1.333v2M2.334 6.06h11.333M14 5.666v5.667c0 2-1 3.333-3.333 3.333H5.333C3 14.666 2 13.333 2 11.333V5.666c0-2 1-3.333 3.333-3.333h5.334C13 2.333 14 3.666 14 5.666z"
        />

        {withDots && (
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10.463 9.133h.006M10.463 11.133h.006M7.998 9.133h.006M7.998 11.133h.006M5.529 9.133h.006M5.529 11.133h.006"
          />
        )}
      </svg>
    </span>
  );
};

export const CalendarWithTickIcon = ({
  size = 12,
  className = "text-black",
}) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 12 12"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M4 1v1.5M8 1v1.5M1.75 4.545h8.5M11 9.5c0 .375-.105.73-.29 1.03-.345.58-.98.97-1.71.97-.505 0-.965-.185-1.315-.5-.155-.13-.29-.29-.395-.47A1.96 1.96 0 0 1 7 9.5a2 2 0 1 1 4 0"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m8.22 9.5.496.495L9.78 9.01"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M10.5 4.25v3.93A2 2 0 0 0 7 9.5c0 .375.105.73.29 1.03.105.18.24.34.395.47H4c-1.75 0-2.5-1-2.5-2.5V4.25c0-1.5.75-2.5 2.5-2.5h4c1.75 0 2.5 1 2.5 2.5"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5.997 6.85h.005M4.148 6.85h.004M4.148 8.35h.004"
        />
      </svg>
    </span>
  );
};

export default CalendarIcon;
